export default "__VITE_ASSET__Pc7TxCWY__"